/**
 * Représente un événement clic sur un élément du menu contextuel d'un tableau du détail.
 */
export class DetailTablePanelContextMenuItemEvent<T> {
    /**
     * Constructeur.
     * @param menuItemId : Identifiant de l'élément du menu selectionné.
     * @param menuItemData : Données attachées à l'élément du menu selectionné.
     */
    constructor(
        public menuItemId: string,
        public menuItemData: T
    ) {}
}
